import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LoadingMfaService } from '../../services/redirect-mfa.service';
import { TranslateService } from '../../../../core/translation/translate.service';

@Component({
  selector: 'loading-mfa',
  templateUrl: './loading-mfa.component.html',
  styleUrls: ['./loading-mfa.component.scss']
})
export class LoadingMfaComponent implements OnInit, OnDestroy {

  isLoadingMFA: BehaviorSubject<boolean>;
  subscriptionLogin: Subscription;
  login: Record<'text' | 'icon', string>;
  translation: string = '';
  constructor(private _loadingMfaServce: LoadingMfaService,
    public _translate: TranslateService,
    ) { }

  ngOnInit(): void {
    this.isLoadingMFA = this._loadingMfaServce.isActive;
    this.subscriptionLogin = this._loadingMfaServce.loginConfig.subscribe((value) => {
      if(value) {
        this.login = value;
      }
    });
    TranslateService.initTranslateSubscription(this);
  }

  ngOnDestroy(): void {
    this.subscriptionLogin.unsubscribe();
  }

  translate(): void {
    this.translation = this._translate.instant(this.login.text);
  }

}
